<template>
  <div>
    <div v-if="store === 0">
      <form-accordion :title="$t('common.security.pem')" :isTitleUpperCase="false" >
        <b-row class="d-flex justify-content-start align-items-center">
          <b-col sm="4" class="form-group">
            <form-write-group-label-input v-model="form.name" isMandatory
              :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
            </form-write-group-label-input>
          </b-col>
          <!--b-col sm="4" v-if="isRightPod" class="form-group">
            <div>
              <span class="filter-item-title">{{ $t('common.security.pod_select') }}</span>
              <span class="color-red">* </span>
              <b-form-select v-model="form.pod" :options="podList" style="font-size:small;"></b-form-select>
            </div>
          </b-col>
          <b-col sm="4" class="form-group"></b-col-->
        </b-row>
      </form-accordion>
      <form-accordion :title="$t('common.security.certificate')" :isTitleUpperCase="false">
        <button class="btn w-auto px-4 btn-tertiary mb-5" @click="addCertificat">{{ $t('common.security.add_certificat') }}</button>
        <div class="rounded p-4 trackingAccordion mb-5" v-for="(certificat, index) in certificatList" :key="index">
          <b-row v-if="certificat.certificate !== null" class="d-flex justify-content-start align-items-center form-group">
            <b-col v-if="certificat.certificate === ''"  sm="4" class="form-group mb-5">
              <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
              <span class="color-red">* </span>
              <b-form-textarea
                style="max-height: none;"
                id="textarea"
                v-model="certificat.certificate"
                @input="processCertificat(certificat)"
                :placeholder="$t('common.enter_something')"
                rows="6">
              </b-form-textarea>
            </b-col>
            <b-col v-if="certificat.certificate !== ''" sm="12" class="form-group mb-5">
              <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
              <span class="color-red">* </span>
              <b-form-textarea
                style="max-height: none;"
                id="textarea"
                v-model="certificat.certificate"
                @input="processCertificat(certificat)"
                :placeholder="$t('common.enter_something')"
                rows="6">
              </b-form-textarea>
            </b-col>
            <b-col sm="6" class="form-group d-flex flex-column mb-5" v-if="certificat.certificate === ''" >
                <span>
                  <span class="filter-item-title">{{ $t('common.security.certificat_file') }}</span>
                  <span class="color-red">* </span>
                </span>
              <input type="file" @change="handleFileUploadCertificat($event, index)" accept=".pem" />
            </b-col>
            <b-col  v-if="certificat.certificate == ''" sm="4" class="form-group"></b-col>
          </b-row>
          <b-row class="d-flex align-items-center form-group">
            <b-col sm="4" class="form-group mb-5">
              <form-write-group-label-input v-model="certificat.name" isMandatory
                :inputLabel="$t('common.security.name')" :placeholderValue="$t('common.security.name')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group mb-5">
              <form-read-group-label-input :inputValue="certificat.startDate"
                :inputLabel="$t('common.security.startDate')" :placeholderValue="$t('common.security.startDate')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group mb-5">
              <form-read-group-label-input :inputValue="certificat.endDate"
                :inputLabel="$t('common.security.endDate')" :placeholderValue="$t('common.security.endDate')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="2" class="form-group mb-5">
            </b-col>
          </b-row>
          <b-row class="d-flex align-items-center form-group">
            <b-col sm="4" class="form-group">
              <form-read-group-label-input :inputValue="certificat.deliveredBy"
                :inputLabel="$t('common.security.deliveredBy')" :placeholderValue="$t('common.security.deliveredBy')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group">
              <form-read-group-label-input :inputValue="certificat.deliveredTo"
                :inputLabel="$t('common.security.deliveredTo')" :placeholderValue="$t('common.security.deliveredTo')">
              </form-read-group-label-input>
            </b-col>
            <b-col sm="4" class="form-group">
            </b-col>
          </b-row>
          <button class="btn w-auto px-4 btn-tertiary" @click="removeCertificat(index, certificat)">{{ $t('common.security.remove_certificat') }}</button>
        </div>
      </form-accordion>
    </div>
    <b-row v-if="store === 0" class="mt-3 justify-content-end">
      <b-col cols="4" lg="2" xl="1" v-if="canSaveTrustStore">
        <b-button variant="primary"
          @click="updateTruststore()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-col>
      <b-col cols="4" lg="2" xl="1" v-else>
        <b-button variant="primary" disabled>
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {errorMessageAlert} from '@/helpers/alert'
import forge from 'node-forge';
import CertificatesList from "@/pages/security/CertificatesList.vue";
import {loadPage} from "@/helpers/routing";

export default {
  name: 'CAFormPEM',
  computed: {
    CertificatesList() {
      return CertificatesList
    }
  },
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-read-group-label-input': formReadGroupLabelInput,
  },
  props: ['store', 'pod', 'certificate', 'id', 'name'],
  data () {
    return {
      form: {
        state: 0,
        privateKey: '',
        certificate: '',
        startDate: '',
        endDate: '',
        name: '',
        nameDisplay: '',
        pod: '',
        password:'',
        id: '',
      },
      text: '',
      certificateText: '',
      login: '',
      password: '',
      showModalElement: false,
      caList: [],
      caListPopUp: [],
      podList: [],
      canSaveTrustStore: false,
      certificatList: []
    }
  },
  watch: {
    certificatList: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
    form: {
      handler() {
        this.checkFormTrustStore()
      },
      deep: true,
    },
  },
  created () {
    this.form.id = this.id
    this.form.name = this.name
    //this.form.pod = this.pod
    this.certificate.forEach(element => {
      this.certificatList.push({
        startDate: element.startDate,
        endDate: element.endDate,
        name: element.name,
        text: '',
        certificate: null,
        nameDisplay: element.cn,
        id: element.id,
        deliveredBy: element.deliveredBy,
        deliveredTo: element.deliveredTo
      })
    })
    let that = this
    this.$engine.security.ca.fetch().then(resp => {
      if (resp.data.ca.length !== 0){
        this.caList.push({text: this.$i18n.t('common.security.select_an_option'), value: ''})
        resp.data.ca.forEach(element => {
          this.caList.push({text: element.name, value: element.id})
        })
      }

    })
    .catch(error => {
      errorMessageAlert(error, that)
    })
    /*this.$engine.routing.pod.fetch()
        .then(resp => {
          if (resp.data.Pods.length != 0){
            this.podList.push({text: this.$i18n.t('common.security.select_an_option'), value: ""})
            resp.data.Pods.forEach(element => {
              this.podList.push({text: element.name, value: element.name})
            })
          }

        })*/
    this.checkFormTrustStore()
  },
  methods: {
    /*isRightPod(){
      return this.$engine.rights.rightIs('pod_consult', true)
    },*/
    addCertificat () {
      this.certificatList.push({startDate: '', endDate: '', name: '',text: '', certificate: '', nameDisplay: ''})
      this.checkFormTrustStore()
    },
    removeCertificat (index, certificate){
      if (certificate.id != '') {
        this.$engine.security.certificates.delete({id: certificate.id})
      }
      this.certificatList.splice(index , 1)
    },
    checkFormTrustStore () {
      let flag = true
      if (this.certificatList.length === 0) {
        flag = false
      }
      if (this.form.name === '') {
        flag = false
      }
      this.certificatList.forEach(element =>{
        if (element.startDate != '' && element.endDate != '' && element.certificate != '' && element.nameDisplay != '' && element.name != ''/* && this.form.pod != ''*/){

        }
        else if (element.id != undefined){

        }
        else {
          flag = false
        }
      })
      if (flag) {
        this.canSaveTrustStore = true
      } else {
        this.canSaveTrustStore = false
      }
    },
    close () {
      this.showModalElement = false
    },
    processCertificat (certificat) {
      try {
        // Traiter le certificate PEM collé dans le textarea
        const certificate = forge.pki.certificateFromPem(certificat.certificate);

        // Extraire les informations du certificate
        const subjectAttributes = certificate.subject.attributes;
        const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName');
        // certificat.name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé';
        certificat.name = '';

        certificat.startDate = certificate.validity.notBefore.toLocaleString().toString();
        certificat.endDate = certificate.validity.notAfter.toLocaleString().toString();

        certificate.issuer.attributes.forEach(e => {
          if (e.name == 'commonName'){
            certificat.deliveredBy = e.value
          }
        })
        certificate.subject.attributes.forEach(e => {
          if (e.name == 'commonName') {
            certificat.deliveredTo = e.value
          }
        })
        // Reconversion du certificat en format PEM (pour l'affichage)
        certificat.certificate = forge.pki.certificateToPem(certificate);

        // Réinitialiser le message d'erreur s'il y en avait
        this.errorMessage = '';

      } catch (err) {
        // En cas d'erreur, afficher un message
        this.errorMessage = this.$i18n.t('common.security.pem_certificate_parsing_error');
        certificat.certificate = '';
        certificat.startDate = '';
        certificat.endDate = '';
      }
    },
    handleFileUploadCertificat (event, index = null) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const pemContent = e.target.result;

        try {
          const certificate = forge.pki.certificateFromPem(pemContent);
          const pemFormattedCert = forge.pki.certificateToPem(certificate)

          this.certificateText = forge.pki.certificateToPem(certificate)


          const startDate = certificate.validity.notBefore.toLocaleString().toString()
          const endDate = certificate.validity.notAfter.toLocaleString().toString()

          const subjectAttributes = certificate.subject.attributes
          const commonNameAttribute = subjectAttributes.find(attr => attr.name === 'commonName')
          // const name = commonNameAttribute ? commonNameAttribute.value : 'Nom non trouvé';

          if (index == null) {
            this.form.certificate = pemFormattedCert
            this.form.startDate = startDate
            this.form.endDate = endDate
            this.form.nameDisplay = commonNameAttribute.value

            certificate.issuer.attributes.forEach(element => {
              if (element.name === 'commonName'){
                this.form.deliveredBy = element.value
              }
            })
            certificate.subject.attributes.forEach(element => {
              if (element.name === 'commonName'){
                this.form.deliveredTo = element.value
              }
            })
          }else{
            this.certificatList[index].certificate = pemFormattedCert
            this.certificatList[index].startDate = startDate
            this.certificatList[index].endDate = endDate
            this.certificatList[index].nameDisplay = commonNameAttribute.value

            certificate.issuer.attributes.forEach(element => {
              if (element.name === 'commonName'){
                this.certificatList[index].deliveredBy = element.value
              }
            })
            certificate.subject.attributes.forEach(element => {
              if (element.name === 'commonName'){
                this.certificatList[index].deliveredTo = element.value
              }
            })
            }

        } catch (err) {
          console.error(this.$i18n.t('common.security.pem_certificate_parsing_error'), err)
        }
      };

      reader.readAsText(file)
    },
    updateTruststore () {
      let that = this
      if (that.form.name != '' || that.form.id != '') {
        let certificates = []
        let flag
        flag = false
        let count = 0
        that.certificatList.forEach(element => {
          if (element){
            /*if (that.form.pod == '' && this.isRightPod) {
              that.$f7.alert(that.$i18n.t('common.security.missing_truststore_pod'), 'Error')
            }*/
            if (element.name == '') {
              that.$f7.alert(that.$i18n.t('common.security.missing_truststore_name'), 'Error')
            }
            let form = {
              name: element.name,
              startDate: element.startDate,
              endDate: element.endDate,
              deliveredBy: element.deliveredBy,
              deliveredTo: element.deliveredTo,
              commonName: element.nameDisplay,
              type: 'SSL'
            }

            /*if (that.isRightPod){
              form.idPod = that.form.pod
            }*/

              if (element.certificate != null){
                form.certificate = element.certificate
                that.$engine.security.certificates.create(form)
                .then(resp => {

                  count++
                  certificates.push(resp.data.idCertificat)

                  let form = {
                    certificates: certificates
                  }
                  form.name = that.form.name
                  form.id = that.id
                  /*if (that.isRightPod){
                    form.idPod = that.form.pod
                  }*/

                  if (that.formHasError()) {
                    return
                  }

                  if (count === that.certificatList.length) {
                    flag = true
                  }
                  if (flag) {
                    that.$engine.security.ca.edit(form)
                    .then(resp => {
                      that.$f7.alert(that.$i18n.t('common.security.updated_truststore'), that.$i18n.t('common.security.update_truststore_2'))

                      loadPage(that, {url: '/security/0'})
                    })
                    .catch(e => {
                      errorMessageAlert(e, that)
                      that.okMessageBox(that.$t('common.security.add_certificate_truststore_error'))
                    })
                  }
                })
                .catch(e => {
                  errorMessageAlert(e, that)
                  that.okMessageBox(that.$t('common.security.cert_addition_error'))
                })
              } else {
                form.id = element.id
                that.$engine.security.certificates.edit(form)
                .then(resp => {

                  count++
                  certificates.push(element.id)

                  let form = {
                    "certificates": certificates
                  }
                  form.name = that.form.name
                  form.id = that.id

                  if (that.formHasError()) {
                    return
                  }
                  /*if (that.isRightPod){
                    form.idPod = that.form.pod
                  }*/

                  if (count === that.certificatList.length){
                    flag = true
                  }
                  if (flag) {
                    that.$engine.security.ca.edit(form)
                    .then(resp => {
                      that.$f7.alert(that.$i18n.t('common.security.updated_truststore'), that.$i18n.t('common.security.update_truststore_2'))

                      loadPage(that, {url: '/security/0'})
                    })
                    .catch(e => {
                      errorMessageAlert(e, that)
                      that.okMessageBox(that.$t('common.security.add_certificate_truststore_error'))
                    })
                  }
                })
                .catch(e => {
                  errorMessageAlert(e, that)
                  that.okMessageBox(that.$t('common.security.cert_addition_error'))
                })
              }
          }
        })
      }
    },
    formHasError () {
      // let that = this
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.name === undefined || this.name === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_name'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
